export default {
    title: "Inicio",
    addOrder: {
        title: "Registrar pedido",
        date_time: "Fecha y Hora",
        order_value: "Valor do pedido",
        client_phone: "Teléfono del cliente",
        success_message: "Pedido registrado con éxito",
        new_client_message: "Nuevo cliente en la base, ¡solicite el registro!",
        not_registered_message: "El cliente aún no se ha registrado",
        anonymous_title: "Pedido anónimo",
        anonymous_body:
            "Está generando un pedido sin informar al cliente. <br /><br />Esto reduce la efectividad y precisión de los informes, siempre recuerde pedir el teléfono al cliente.",
        suspect_value_title: "¡Alerta de valor sospechoso! ({0})",
        suspect_value_body:
            'Está generando un pedido con un valor de <span style="display: inline-block">{0}</span> que está muy por encima de lo normal. <br /><br />Haga clic en confirmar si esto não es un error.',
        register_button: "Registrar Pedido",
        save_button: "Guardar",
        value_error: "Por favor, verifique el valor del pedido",
        generic_success: "Pedido guardado con éxito",
        personalized_success: "Gracias {0}, ¡ya tienes {1} puntos!",
        welcome_points: "Bienvenido, ¡ya tienes {0} puntos!",
        thanks_points: "Gracias, ¡ya tienes {0} puntos!",
    },
    searchClient: {
        title: "Buscar cliente",
        confirm_reward_title: "Confirmar canje de premio",
        confirm_reward_body:
            '¿Canjear o premio "{0}" por {1} puntos? <br /> Esta acción es irreversible.',
        reward_success_title: "¡Premio canjeado con éxito!",
        reward_success_body:
            'El premio "{0}" fue canjeado con éxito por {1} puntos. <br />',
        client_points_title: "{0} tiene <strong>{1}</strong> puntos",
        client_coupons_title: "Cupones {0}",
        processing_coupons_title: "Cupones en procesamiento",
        processing_coupons_desc:
            "Estos cupones aún se están procesando y pronto se generará el código.",
        automation_origin: "Automatización de origen: {0}",
        active_coupons_title: "Cupones activos",
        validity: "Validez:",
        until: "hasta:",
        not_registered: "Cliente no registrado",
        send_sms_link: "Enviar SMS de Registro",
        coupons_label: "Cupones:",
        processing_label: "({0} en procesamiento)",
        view_coupons: "Ver cupones",
        points_label: "Puntos:",
        view_rewards: "Ver recompensas",
        orders_label: "Pedidos:",
        birthdate_label: "Cumpleaños:",
        email_label: "E-mail:",
        phone_label: "Teléfono:",
        view_profile: "Ver perfil",
        coupon_not_yet_valid: "El cupón aún no es válido",
        coupon_expired: "El cupón ya ha expirado",
        sms_success: "¡Enlace enviado con éxito!",
        sms_error:
            "¡Ups! Ocurrió un error al enviar el enlace. Por favor, intente de nuevo más tarde.",
    },
    validateCoupon: {
        title: "Validar cupón",
        confirm_use_title: "Confirmar uso del cupón",
        confirm_use_body:
            "¿Conceder el beneficio de {0}? <br /> Esta acción es irreversible.",
        used_success_title: "Cupón utilizado",
        used_success_body:
            "Cupón de {0} se utilizó con éxito. <br /> El cupón {1} ya no es válido",
        error_expired: "Cupón expirado",
        error_not_yet_valid: "El cupón será válido a partir de",
        error_used: "Cupón ya utilizado",
        error_not_found: "Cupón inválido",
        valid_coupon: "Cupón válido",
        validate_button: "Validar cupón",
        use_button: "Usar cupón",
    },
};
